export const scrollToView = (id: string, options?: ScrollIntoViewOptions) => {
  const element = document.getElementById(id);
  setTimeout(() => {
    if (element) element.scrollIntoView(options || { behavior: 'smooth', block: 'center', inline: 'center' });
  }, 300);
};
